// src/store/services/GestionesTiemposTranscurridosHistorico.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class GestionesTiemposTranscurridosHistorico extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'GestionesTiemposTranscurridosHistorico';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'gestiones-tiempos-transcurridos-historico';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'GestionesTiemposTranscurridosHistorico',
    Model: GestionesTiemposTranscurridosHistorico,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  